import type { ReactNode } from 'react';

export const symbol_replace_image: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m461-225-32-43q-5-6-12-6t-12 6l-40 54q-5 8-.75 16t12.75 8h206q9 0 13.5-8t-1.5-16l-57-74q-5-6-11.5-5.5T515-288l-54 63ZM300-80q-24.75 0-42.37-17.63Q240-115.25 240-140v-360q0-24.75 17.63-42.38Q275.25-560 300-560h360q24.75 0 42.38 17.62Q720-524.75 720-500v360q0 24.75-17.62 42.37Q684.75-80 660-80H300Zm0-60h360v-360H300v360Zm0 0v-360 360Zm510-480H640q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h94q-42-66-109-103t-145-37q-90 0-164.5 46.5T204-648q-7 14-18 18t-22-1q-11-5-16-15.5t0-21.5q42-97 132.5-154.5T480-880q91 0 170.5 42.5T780-719v-101q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v170q0 12.75-8.62 21.37Q822.75-620 810-620Z"
		/>
	</svg>
);
